import { useTranslations } from 'next-intl';
import { RightArrow } from 'assets/icons';
import { FAQContainer, FAQElement } from 'components/shared/FAQ';
import { Container } from '..';
import { H2 } from './styleConstants';
import CustomLink from 'components/shared/CustomLink';
import styles from './FAQSection.module.css';
import {
  ALL_FAQ_KEYS,
  getBloodVisionFaqData,
} from 'content/products/bloodVisionFaqData';

export {
  ALL_FAQ_KEYS,
  LANDING_FAQ_KEYS,
  getBloodVisionFaqData,
} from 'content/products/bloodVisionFaqData';

type FAQ = {
  title: string;
  description: React.ReactNode;
};

export const useBloodVisionFaqData = (
  keys: readonly (typeof ALL_FAQ_KEYS)[number][],
): FAQ[] => {
  const t = useTranslations('bloodVision');
  return getBloodVisionFaqData(t, keys);
};

export const FAQSection = ({
  className,
  faqData,
}: {
  className?: string;
  faqData: {
    title: string;
    description: React.ReactNode;
  }[];
}) => {
  const t = useTranslations('bloodVision');
  return (
    <section className={className ? `${styles.root} ${className}` : styles.root}>
      <Container>
        <H2>{t('faqSection.title')}</H2>
        <FAQContainer>
          {faqData.map((faq, i) => {
            return <FAQElement key={i} {...faq} />;
          })}
        </FAQContainer>
        <div className="" style={{ textAlign: 'center' }}>
          <CustomLink href="/blood-vision/faq">
            {t('faqSection.seeAll')} <RightArrow fill="#000000" />
          </CustomLink>
        </div>
      </Container>
    </section>
  );
};
